export default __webpack_public_path__ + "static/media/irrigation_timing_midnight.46ce0892.jpg";